const iconTypes = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'file-spreadsheet',
  'application/vnd.ms-excel': 'file-spreadsheet',
  'application/xls': 'file-spreadsheet',
  'application/excel': 'file-spreadsheet',
  'application/pdf': 'pdf',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'file-graph',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'file-text',
  'application/msword': 'file-text',
  'application/octet-stream': 'document',
  'application/zip': 'file-zip',
  'application/x-zip-compressed': 'file-zip',
  'multipart/x-zip': 'file-zip'
};

/**
 * @param {String} mimeType
 * @param {Integer} size
 * @returns {String}
*/
export function getFileIcon(mimeType, size) {
  if (!mimeType) {
    return `document_${size}`;
  }

  if (iconTypes[mimeType]) {
    return `${iconTypes[mimeType]}_${size}`;
  }

  const tokens = mimeType.split('/');

  if (tokens[0] === 'image') {
    return `file-image_${size}`;
  }

  if (tokens[0] === 'video') {
    return `file-video_${size}`;
  }

  if (tokens[0] === 'audio') {
    return `file-audio_${size}`;
  }
  if (tokens[0] === 'text') {
    return `file-text_${size}`;
  }

  return `document_${size}`;
}

export default {};
